import { render, staticRenderFns } from "./TravelAdd.vue?vue&type=template&id=1f2e442c&"
import script from "./TravelAdd.vue?vue&type=script&lang=js&"
export * from "./TravelAdd.vue?vue&type=script&lang=js&"
import style0 from "./TravelAdd.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports